// import React, { useState, useEffect, useCallback } from 'react';
// import { CreditCard, Plus, Search, Edit2, Trash2, ToggleLeft } from 'lucide-react';
// import { Card, Button, Input, Modal, Badge } from '../components/UI';
// import Pagination from '../components/Pagination';
// import { webPayAPI } from '../api/apiClient';
// import toast from 'react-hot-toast';

// const WEBPAY_PER_PAGE = 20;

// const defaultFormState = {
//   name: '',
//   apiKey: '',
//   secretKey: '',
//   merchantId: '',
//   baseUrl: 'https://api.webpay.example.com',
//   logoUrl: '',
//   description: '',
//   supportedCurrencies: ['USD'],
//   isActive: true,
//   isLive: false,
//   webhookUrl: '',
//   minTransactionAmount: 1,
//   maxTransactionAmount: 100000,
//   transactionFee: 0,
//   displayOrder: 1,
// };

// const WebPayPage = () => {
//   const [webPayList, setWebPayList] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState('');
//   const [statusFilter, setStatusFilter] = useState('');
//   const [liveFilter, setLiveFilter] = useState('');
//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editingWebPay, setEditingWebPay] = useState(null);
//   const [formData, setFormData] = useState(defaultFormState);

//   const loadWebPayList = useCallback(async () => {
//     try {
//       setLoading(true);
//       const response = await webPayAPI.get(
       
//       );
//       const data = response.data.data;
//       setWebPayList(data.webPayList || []);
//       setTotalPages(data.pagination.pages || 1);
//     } catch (error) {
//       toast.error('Failed to load WebPay configurations');
//     } finally {
//       setLoading(false);
//     }
//   }, [page, search, statusFilter, liveFilter]);

//   useEffect(() => {
//     loadWebPayList();
//   }, [loadWebPayList]);

//   const resetForm = () => {
//     setFormData(defaultFormState);
//     setEditingWebPay(null);
//   };

//   const openCreateModal = () => {
//     resetForm();
//     setIsModalOpen(true);
//   };

//   const openEditModal = (webPay) => {
//     setEditingWebPay(webPay);
//     setFormData({
//       name: webPay.websubscriptionurl || '',
//       apiKey: webPay.guidevideurl || '',
      
//     });
//     setIsModalOpen(true);
//   };

//   const handleSaveWebPay = async () => {
//     try {
//       const { name, apiKey, } = formData;

//       if (!name || !apiKey) {
//         toast.error('Name, API Key, Secret Key, and Merchant ID are required');
//         return;
//       }

//       if (editingWebPay) {
//         await webPayAPI.update(editingWebPay._id, formData);
//         toast.success('WebPay configuration updated successfully');
//       } else {
//         await webPayAPI.create(formData);
//         toast.success('WebPay configuration created successfully');
//       }

//       setIsModalOpen(false);
//       resetForm();
//       loadWebPayList();
//     } catch (error) {
//       toast.error(editingWebPay ? 'Failed to update WebPay' : 'Failed to create WebPay');
//     }
//   };

//   const handleDeleteWebPay = async (id) => {
//     if (!window.confirm('Are you sure you want to delete this WebPay configuration?')) {
//       return;
//     }

//     try {
//       await webPayAPI.delete(id);
//       toast.success('WebPay configuration deleted successfully');
//       loadWebPayList();
//     } catch (error) {
//       toast.error('Failed to delete WebPay configuration');
//     }
//   };

//   const handleToggleActive = async (webPay) => {
//     try {
//       await webPayAPI.toggleActive(webPay._id);
//       toast.success(`WebPay ৳{webPay.isActive ? 'deactivated' : 'activated'}`);
//       loadWebPayList();
//     } catch (error) {
//       toast.error('Failed to toggle WebPay status');
//     }
//   };

//   const handleToggleLive = async (webPay) => {
//     try {
//       await webPayAPI.toggleLive(webPay._id);
//       toast.success(`WebPay switched to ৳{webPay.isLive ? 'test' : 'live'} mode`);
//       loadWebPayList();
//     } catch (error) {
//       toast.error('Failed to toggle WebPay live mode');
//     }
//   };

//   return (
//     <div className="space-y-6">
//       <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
//         <div>
//           <h1 className="text-3xl font-bold text-white flex items-center space-x-3">
//             <CreditCard size={32} className="text-blue-400" />
//             <span>WebPay Management</span>
//           </h1>
//           <p className="text-gray-400 mt-2">Manage WebPay gateway integrations and configurations.</p>
//         </div>
//         <Button variant="primary" onClick={openCreateModal} className="flex items-center space-x-2">
//           <Plus size={18} />
//           <span>Add WebPay</span>
//         </Button>
//       </div>

//       <Card>
//         <div className="grid gap-4 md:grid-cols-4">
//           <div className="relative md:col-span-2">
//             <Search className="absolute left-3 top-3 text-gray-500" size={18} />
//             <input
//               type="text"
//               placeholder="Search WebPay..."
//               value={search}
//               onChange={(e) => {
//                 setSearch(e.target.value);
//                 setPage(1);
//               }}
//               className="w-full pl-10 pr-4 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//           </div>

//           <div className="flex items-center space-x-2">
//             <Button
//               variant={statusFilter === '' ? 'primary' : 'secondary'}
//               onClick={() => {
//                 setStatusFilter('');
//                 setPage(1);
//               }}
//               className="flex-1"
//             >
//               All
//             </Button>
//             <Button
//               variant={statusFilter === 'true' ? 'primary' : 'secondary'}
//               onClick={() => {
//                 setStatusFilter('true');
//                 setPage(1);
//               }}
//               className="flex-1"
//             >
//               Active
//             </Button>
//           </div>

//           <div className="flex items-center space-x-2">
//             <Button
//               variant={liveFilter === '' ? 'primary' : 'secondary'}
//               onClick={() => {
//                 setLiveFilter('');
//                 setPage(1);
//               }}
//               className="flex-1"
//             >
//               All Modes
//             </Button>
//             <Button
//               variant={liveFilter === 'true' ? 'success' : 'secondary'}
//               onClick={() => {
//                 setLiveFilter('true');
//                 setPage(1);
//               }}
//               className="flex-1"
//             >
//               Live
//             </Button>
//           </div>
//         </div>
//       </Card>

//       <Card>
//         {loading ? (
//           <div className="text-center py-10">
//             <div className="inline-block w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
//           </div>
//         ) : webPayList.length === 0 ? (
//           <div className="text-center py-10">
//             <p className="text-gray-400">No WebPay configurations found.</p>
//           </div>
//         ) : (
//           <div className="overflow-x-auto">
//             <table className="w-full text-left">
//               <thead>
//                 <tr className="border-b border-gray-700 text-sm text-gray-400">
//                   <th className="px-4 py-3">Name</th>
//                   <th className="px-4 py-3">Merchant ID</th>
//                   <th className="px-4 py-3">Base URL</th>
//                   <th className="px-4 py-3">Status</th>
//                   <th className="px-4 py-3">Mode</th>
//                   <th className="px-4 py-3">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {webPayList.map((webPay) => (
//                   <tr key={webPay._id} className="border-b border-gray-700 hover:bg-gray-700/50">
//                     <td className="px-4 py-4 text-white font-medium">{webPay.name}</td>
//                     <td className="px-4 py-4 text-gray-300 text-sm">{webPay.merchantId}</td>
//                     <td className="px-4 py-4 text-gray-300 text-sm truncate">{webPay.baseUrl}</td>
//                     <td className="px-4 py-4">
//                       <Badge variant={webPay.isActive ? 'success' : 'danger'}>
//                         {webPay.isActive ? 'Active' : 'Inactive'}
//                       </Badge>
//                     </td>
//                     <td className="px-4 py-4">
//                       <Badge variant={webPay.isLive ? 'warning' : 'secondary'}>
//                         {webPay.isLive ? 'Live' : 'Test'}
//                       </Badge>
//                     </td>
//                     <td className="px-4 py-4 space-x-2 flex flex-wrap">
//                       <Button
//                         variant="secondary"
//                         onClick={() => handleToggleActive(webPay)}
//                         className="px-2 py-1"
//                         title={webPay.isActive ? 'Deactivate' : 'Activate'}
//                       >
//                         <ToggleLeft size={14} />
//                       </Button>
//                       <Button
//                         variant={webPay.isLive ? 'warning' : 'secondary'}
//                         onClick={() => handleToggleLive(webPay)}
//                         className="px-2 py-1"
//                         title={webPay.isLive ? 'Switch to Test' : 'Switch to Live'}
//                       >
//                         {webPay.isLive ? 'Live' : 'Test'}
//                       </Button>
//                       <Button
//                         variant="primary"
//                         onClick={() => openEditModal(webPay)}
//                         className="px-2 py-1"
//                       >
//                         <Edit2 size={14} />
//                       </Button>
//                       <Button
//                         variant="danger"
//                         onClick={() => handleDeleteWebPay(webPay._id)}
//                         className="px-2 py-1"
//                       >
//                         <Trash2 size={14} />
//                       </Button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}

//         <div className="mt-6">
//           <Pagination
//             currentPage={page}
//             totalPages={totalPages}
//             onPageChange={(newPage) => {
//               if (newPage >= 1 && newPage <= totalPages) {
//                 setPage(newPage);
//               }
//             }}
//           />
//         </div>
//       </Card>

//       <Modal
//         isOpen={isModalOpen}
//         onClose={() => {
//           setIsModalOpen(false);
//           resetForm();
//         }}
//         title={editingWebPay ? 'Edit WebPay Configuration' : 'Add WebPay Configuration'}
//         footer={
//           <>
//             <Button
//               variant="secondary"
//               onClick={() => {
//                 setIsModalOpen(false);
//                 resetForm();
//               }}
//             >
//               Cancel
//             </Button>
//             <Button variant="primary" onClick={handleSaveWebPay}>
//               {editingWebPay ? 'Save Changes' : 'Create WebPay'}
//             </Button>
//           </>
//         }
//       >
//         <div className="grid gap-4">
//           <Input
//             label="Name"
//             value={formData.name}
//             onChange={(e) => setFormData({ ...formData, name: e.target.value })}
//             placeholder="e.g., Stripe, PayPal, Square"
//           />
//           <Input
//             label="API Key"
//             value={formData.apiKey}
//             onChange={(e) => setFormData({ ...formData, apiKey: e.target.value })}
//             placeholder="Your API Key"
//           />
//           <Input
//             label="Secret Key"
//             type="password"
//             value={formData.secretKey}
//             onChange={(e) => setFormData({ ...formData, secretKey: e.target.value })}
//             placeholder="Your Secret Key"
//           />
//           <Input
//             label="Merchant ID"
//             value={formData.merchantId}
//             onChange={(e) => setFormData({ ...formData, merchantId: e.target.value })}
//             placeholder="Merchant ID"
//           />
//           <Input
//             label="Base URL"
//             value={formData.baseUrl}
//             onChange={(e) => setFormData({ ...formData, baseUrl: e.target.value })}
//             placeholder="https://api.webpay.example.com"
//           />
//           <Input
//             label="Logo URL"
//             value={formData.logoUrl}
//             onChange={(e) => setFormData({ ...formData, logoUrl: e.target.value })}
//             placeholder="https://example.com/logo.png"
//           />
//           <Input
//             label="Webhook URL"
//             value={formData.webhookUrl}
//             onChange={(e) => setFormData({ ...formData, webhookUrl: e.target.value })}
//             placeholder="https://yoursite.com/webhook"
//           />
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             <Input
//               label="Min Amount"
//               type="number"
//               min="0"
//               value={formData.minTransactionAmount}
//               onChange={(e) => setFormData({ ...formData, minTransactionAmount: Number(e.target.value) })}
//             />
//             <Input
//               label="Max Amount"
//               type="number"
//               min="0"
//               value={formData.maxTransactionAmount}
//               onChange={(e) => setFormData({ ...formData, maxTransactionAmount: Number(e.target.value) })}
//             />
//           </div>
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             <Input
//               label="Transaction Fee (%)"
//               type="number"
//               min="0"
//               step="0.1"
//               value={formData.transactionFee}
//               onChange={(e) => setFormData({ ...formData, transactionFee: Number(e.target.value) })}
//             />
//             <Input
//               label="Display Order"
//               type="number"
//               min="1"
//               value={formData.displayOrder}
//               onChange={(e) => setFormData({ ...formData, displayOrder: Number(e.target.value) })}
//             />
//           </div>
//           <div className="flex items-center space-x-4 pt-4">
//             <div className="flex items-center space-x-2">
//               <input
//                 id="isActive"
//                 type="checkbox"
//                 checked={formData.isActive}
//                 onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
//                 className="h-4 w-4 rounded border-gray-600 bg-gray-700 text-blue-500"
//               />
//               <label htmlFor="isActive" className="text-white text-sm">
//                 Active
//               </label>
//             </div>
//             <div className="flex items-center space-x-2">
//               <input
//                 id="isLive"
//                 type="checkbox"
//                 checked={formData.isLive}
//                 onChange={(e) => setFormData({ ...formData, isLive: e.target.checked })}
//                 className="h-4 w-4 rounded border-gray-600 bg-gray-700 text-green-500"
//               />
//               <label htmlFor="isLive" className="text-white text-sm">
//                 Live Mode
//               </label>
//             </div>
//           </div>
//         </div>
//       </Modal>
//     </div>
//   );
// };

// export default WebPayPage;


// import React, { useState, useEffect } from 'react';
// import { CreditCard, Edit2 } from 'lucide-react';
// import { Card, Button, Input, Modal } from '../components/UI';
// import { webPayAPI } from '../api/apiClient';
// import toast from 'react-hot-toast';

// const defaultFormState = {
//   websubscriptionurl: '',
//   guidevideurl: '',
//   subsmonthlyprice: 0,
// };

// const WebPayPage = () => {
//   const [loading, setLoading] = useState(true);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const [webPay, setWebPay] = useState(defaultFormState);
//   const [formData, setFormData] = useState(defaultFormState);

//   const loadWebPay = async () => {
//     try {
//       setLoading(true);

//       const response = await webPayAPI.get();

//       const data = response.data.data || response.data;

//       setWebPay({
//         websubscriptionurl: data.websubscriptionurl || '',
//         guidevideurl: data.guidevideurl || '',
//         subsmonthlyprice: data.subsmonthlyprice || 0,
//       });

//       setFormData({
//         websubscriptionurl: data.websubscriptionurl || '',
//         guidevideurl: data.guidevideurl || '',
//         subsmonthlyprice: data.subsmonthlyprice || 0,
//       });
//     } catch (error) {
//       console.error(error);
//       toast.error('Failed to load WebPay settings');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     loadWebPay();
//   }, []);

//   const openEditModal = () => {
//     setFormData({
//       websubscriptionurl: webPay.websubscriptionurl,
//       guidevideurl: webPay.guidevideurl,
//       subsmonthlyprice: webPay.subsmonthlyprice,
//     });

//     setIsModalOpen(true);
//   };

//   const handleSave = async () => {
//     try {
//       if (!formData.websubscriptionurl.trim()) {
//         toast.error('Subscription URL is required');
//         return;
//       }

//       await webPayAPI.update(formData);

//       toast.success('WebPay settings updated successfully');

//       setIsModalOpen(false);

//       loadWebPay();
//     } catch (error) {
//       console.error(error);
//       toast.error('Failed to update settings');
//     }
//   };

//   if (loading) {
//     return (
//       <div className="flex justify-center py-20">
//         <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="space-y-6">
//       {/* Header */}
//       <div>
//         <h1 className="text-3xl font-bold text-white flex items-center gap-3">
//           <CreditCard className="text-blue-500" size={32} />
//           WebPay Settings
//         </h1>

//         <p className="text-gray-400 mt-2">
//           Manage subscription payment settings.
//         </p>
//       </div>

//       {/* Settings Card */}
//       <Card>
//         <div className="space-y-6">

//           <div>
//             <p className="text-sm text-gray-400 mb-1">
//               Subscription URL
//             </p>

//             <p className="text-white break-all">
//               {webPay.websubscriptionurl || 'Not Configured'}
//             </p>
//           </div>

//           <div>
//             <p className="text-sm text-gray-400 mb-1">
//               Guide Video URL
//             </p>

//             <p className="text-white break-all">
//               {webPay.guidevideurl || 'Not Configured'}
//             </p>
//           </div>

//           <div>
//             <p className="text-sm text-gray-400 mb-1">
//               Monthly Subscription Price
//             </p>

//             <p className="text-green-400 text-2xl font-bold">
//               ৳ {webPay.subsmonthlyprice}
//             </p>
//           </div>

//           <Button
//             variant="primary"
//             onClick={openEditModal}
//             className="flex items-center gap-2"
//           >
//             <Edit2 size={18} />
//             Edit Settings
//           </Button>

//         </div>
//       </Card>

//       {/* Edit Modal */}
//       <Modal
//         isOpen={isModalOpen}
//         onClose={() => setIsModalOpen(false)}
//         title="Edit WebPay Settings"
//         footer={
//           <>
//             <Button
//               variant="secondary"
//               onClick={() => setIsModalOpen(false)}
//             >
//               Cancel
//             </Button>

//             <Button
//               variant="primary"
//               onClick={handleSave}
//             >
//               Save Changes
//             </Button>
//           </>
//         }
//       >
//         <div className="space-y-4">

//           <Input
//             label="Subscription URL"
//             placeholder="https://subscription.telxtv.com/pay"
//             value={formData.websubscriptionurl}
//             onChange={(e) =>
//               setFormData({
//                 ...formData,
//                 websubscriptionurl: e.target.value,
//               })
//             }
//           />

//           <Input
//             label="Guide Video URL"
//             placeholder="https://youtube.com/watch?v=xxxx"
//             value={formData.guidevideurl}
//             onChange={(e) =>
//               setFormData({
//                 ...formData,
//                 guidevideurl: e.target.value,
//               })
//             }
//           />

//           <Input
//             label="Monthly Subscription Price"
//             type="number"
//             min="0"
//             value={formData.subsmonthlyprice}
//             onChange={(e) =>
//               setFormData({
//                 ...formData,
//                 subsmonthlyprice: Number(e.target.value),
//               })
//             }
//           />

//         </div>
//       </Modal>
//     </div>
//   );
// };

// export default WebPayPage;


import React, { useEffect, useState } from 'react';
import {
  CreditCard,
  Edit3,
  ExternalLink,
  Youtube,
  DollarSign,
  Save,
} from 'lucide-react';
import { webPayAPI } from '../api/apiClient';
import toast from 'react-hot-toast';

const WebPayPage = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [formData, setFormData] = useState({
    webSubscriptionUrl: '',
    guideVideoUrl: '',
    subsMonthlyPrice: 0,
  });

  const loadWebPay = async () => {
    try {
      setLoading(true);

      const response = await webPayAPI.get();

      if (response.data.success) {
        setFormData({
          webSubscriptionUrl:
            response.data.data.webSubscriptionUrl || '',
          guideVideoUrl:
            response.data.data.guideVideoUrl || '',
          subsMonthlyPrice:
            response.data.data.subsMonthlyPrice || 0,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error('Failed to load WebPay settings');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadWebPay();
  }, []);

  const handleSave = async () => {
    try {
      setSaving(true);

      const payload = {
        webSubscriptionUrl: formData.webSubscriptionUrl,
        guideVideoUrl: formData.guideVideoUrl,
        subsMonthlyPrice: Number(formData.subsMonthlyPrice),
      };

      const response = await webPayAPI.update(payload);

      if (response.data.success) {
        toast.success('Settings updated successfully');
        await loadWebPay();
      }
    } catch (error) {
      console.error(error);

      toast.error(
        error?.response?.data?.message ||
          'Failed to update settings'
      );
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-[400px]">
        <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="p-6 space-y-6">

      {/* Header */}
      <div className="flex items-center gap-4">
        <div className="p-4 rounded-2xl bg-blue-600">
          <CreditCard size={30} className="text-white" />
        </div>

        <div>
          <h1 className="text-3xl font-bold text-white">
            WebPay Settings
          </h1>

          <p className="text-slate-400">
            Manage subscription payment configuration
          </p>
        </div>
      </div>

      {/* Stats */}
      <div className="grid gap-6 md:grid-cols-3">

        <div className="bg-slate-800 border border-slate-700 rounded-2xl p-6">
          <div className="flex items-center justify-between">
            <DollarSign className="text-green-400" />
            <span className="text-green-400 text-sm">
              Active Price
            </span>
          </div>

          <h2 className="text-4xl font-bold text-white mt-4">
            ৳{formData.subsMonthlyPrice}
          </h2>

          <p className="text-slate-400 mt-2">
            Monthly Subscription
          </p>
        </div>

        <div className="bg-slate-800 border border-slate-700 rounded-2xl p-6">
          <div className="flex items-center justify-between">
            <ExternalLink className="text-blue-400" />
            <span className="text-blue-400 text-sm">
              Subscription URL
            </span>
          </div>

          <p className="text-white text-sm break-all mt-4">
            {formData.webSubscriptionUrl || 'Not Configured'}
          </p>
        </div>

        <div className="bg-slate-800 border border-slate-700 rounded-2xl p-6">
          <div className="flex items-center justify-between">
            <Youtube className="text-red-400" />
            <span className="text-red-400 text-sm">
              Guide Video
            </span>
          </div>

          <a
            href={formData.guideVideoUrl}
            target="_blank"
            rel="noreferrer"
            className="text-white text-sm break-all mt-4 block hover:text-blue-400"
          >
            {formData.guideVideoUrl || 'Not Configured'}
          </a>
        </div>

      </div>

      {/* Settings Form */}
      <div className="bg-slate-800 border border-slate-700 rounded-2xl p-6">

        <div className="flex items-center gap-3 mb-6">
          <Edit3 className="text-blue-400" />
          <h2 className="text-xl font-semibold text-white">
            Edit Configuration
          </h2>
        </div>

        <div className="grid gap-5">

          <div>
            <label className="block text-sm text-slate-300 mb-2">
              Subscription URL
            </label>

            <input
              type="text"
              value={formData.webSubscriptionUrl}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  webSubscriptionUrl: e.target.value,
                })
              }
              className="w-full bg-slate-900 border border-slate-700 rounded-xl px-4 py-3 text-white outline-none focus:border-blue-500"
              placeholder="https://subscription.telxtv.com/pay?uid="
            />
          </div>

          <div>
            <label className="block text-sm text-slate-300 mb-2">
              Guide Video URL
            </label>

            <input
              type="text"
              value={formData.guideVideoUrl}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  guideVideoUrl: e.target.value,
                })
              }
              className="w-full bg-slate-900 border border-slate-700 rounded-xl px-4 py-3 text-white outline-none focus:border-blue-500"
              placeholder="https://youtube.com/watch?v=xxxx"
            />
          </div>

          <div>
            <label className="block text-sm text-slate-300 mb-2">
              Monthly Subscription Price
            </label>

            <input
              type="number"
              value={formData.subsMonthlyPrice}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  subsMonthlyPrice: Number(e.target.value),
                })
              }
              className="w-full bg-slate-900 border border-slate-700 rounded-xl px-4 py-3 text-white outline-none focus:border-blue-500"
            />
          </div>

          <button
            onClick={handleSave}
            disabled={saving}
            className="flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-xl font-semibold transition-all disabled:opacity-50"
          >
            <Save size={18} />

            {saving ? 'Saving...' : 'Save Changes'}
          </button>

        </div>

      </div>

    </div>
  );
};

export default WebPayPage;